
import { defineComponent, ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useMedia } from '@/utils/useMedia'
import { getUser, useEvent } from '@coderhouse/common'
import { getBanners } from '@/api/banner.api'

export default defineComponent({
  components: {},
  setup() {
    const { t } = useI18n()
    const isDesktop = useMedia('(min-width: 1024px)')
    const user = ref()
    const banner = ref()
    const showBanner = ref(false)

    const onClickCta = (url: string) => {
      console.log('onClickCta', url)
    }

    const closeBanner = () => {
      showBanner.value = false
      window.localStorage.setItem('closedBanner', 'true')
    }

    onMounted(async () => {
      user.value = await getUser()
      banner.value = await getBanners(user.value.country)
      showBanner.value = window.localStorage.getItem('closedBanner') !== 'true'
    })

    return { t, isDesktop, banner, showBanner, closeBanner, onClickCta }
  }
})
